<div class="mb-3">
  @if (appealsService.messageWithdrawal == 'SUCCESS_CONTINUANCE') {
  <nh-alert type="success" [isOpen]="appealsService.showMessageWithdrawal">
    @if (appealsService.messageWithdrawal == 'SUCCESS_CONTINUANCE') {
    <div class="col message">
      <span>{{ "WITHDRAWAL_SUBMITTED" | globalTranslate }}</span>
    </div>
    }
  </nh-alert>
  } @if (appealsService.messageWithdrawal == 'ERROR_MESSAGE') {
  <nh-alert type="warning" [isOpen]="appealsService.showMessageWithdrawal">
    @if (appealsService.messageWithdrawal == 'ERROR_MESSAGE') {
    <div class="col message">
      <span>{{ "ERROR_WITHDRAWL_SUBMIT" | globalTranslate }}</span>
    </div>
    }
  </nh-alert>
  }
  <div class="bg-custom">
    <div class="container">
      @if (memberInfo) {
      <div>
        <h1 class="section-header">
          {{ "WITHDRAWAL_DETAILS" | globalTranslate }}
        </h1>
        <hr />
        <div>
          <p class="mb-4">{{ "WITHDRAWAL_MSG" | globalTranslate }}</p>
        </div>
        <div>
          <p class="mb-0 text-color">
            <strong>{{
              "NAME_OF_REQUESTER_WITHDRAWAL" | globalTranslate
            }}</strong
            ><strong>{{ ": " }}</strong
            >{{ memberInfo.requesterName }}
          </p>
          <br />
          <p class="mb-0 text-color">
            <strong>{{ "APPEAL_NUMBER_WITHDRAWAL" | globalTranslate }}</strong>
            <strong>{{ ": " }}</strong
            >{{ memberInfo.appealNumber }}
          </p>
          <br />
          <p class="mb-0 text-color">
            <strong>{{ "APPEAL_REASON_WITHDRAWAL" | globalTranslate }}</strong>
            <strong>{{ ": " }}</strong
            >{{ memberInfo.appealReasonDescription | globalTranslate }}
          </p>
          <br />
          <p class="mb-0 text-color">
            <strong>{{ "APPEAL_STATUS_WITHDRAWAL" | globalTranslate }}</strong>
            <strong>{{ ": " }}</strong
            >{{ memberInfo.appealStatusDesc | globalTranslate }}
          </p>
          <br />
          <p class="mb-0 text-color">
            <strong>{{ "COVERAGE_TYPE_WITHDRAWAL" | globalTranslate }}</strong>
            <strong>{{ ": " }}</strong
            >{{ memberInfo.continueBenefitsDescription | globalTranslate }}
          </p>
          <br />
          <form [formGroup]="appealWithdrawalForm">
            <nh-field
              [attr.aria-required]="true"
              class="textcolor"
              id="app_con_submittedby"
              [mandatory]="true"
              label="{{ 'SUBMITTEDBY_CONTINUANCE' | globalTranslate }}"
            >
              <div>
                <p class="note_padding">
                  {{ "WITHDRAW_NOTE_SUBMITTEDBY" | globalTranslate }}
                </p>
              </div>
              <input
                type="text"
                class="form-control"
                name="submittedBy"
                formControlName="submittedBy"
                [attr.aria-label]="'SUBMITTEDBY_CONTINUANCE' | globalTranslate"
                autofocus="true"
                (input)="submittedValidator($event)"
                maxlength="2000"
              />
            </nh-field>
            <p></p>
            <nh-field
              [attr.aria-required]="false"
              [isRow]="true"
              [mandatory]="false"
              label="{{ 'PHONE_NUMBER_WITHDRAWAL' | globalTranslate }}"
            >
              <input
                type="text"
                name="phoneNumber"
                formControlName="phoneNumber"
                [attr.aria-label]="'PHONE_NUMBER_WITHDRAWAL' | globalTranslate"
                class="form-control mt-2"
                mask="000-000-0000"
                placeholder="XXX-XXX-XXXX"
              />
            </nh-field>
            <nh-field
              [attr.aria-required]="true"
              class="textcolor"
              id="app_con_relationship"
              [mandatory]="true"
              label="{{ 'REQUEST_RELATIONSHIP_CONTINUANCE' | globalTranslate }}"
            >
              <div>
                <p class="rel_pad">
                  {{ "WITHDRAW_NOTE_RELATIONSHIP" | globalTranslate }}
                </p>
              </div>
              <nh-count>
                <textarea
                  maxlength="2000"
                  class="form-control"
                  name="relationshipWithAppellant"
                  formControlName="relationshipWithAppellant"
                  [attr.aria-label]="
                    'REQUEST_RELATIONSHIP_CONTINUANCE' | globalTranslate
                  "
                  rows="5"
                  autofocus="true"
                >
                </textarea>
              </nh-count>
            </nh-field>
            <nh-field
              [attr.aria-required]="true"
              class="textcolor"
              id="app_con_comments"
              [mandatory]="true"
              label="{{ 'REQUEST_COMMENTS_WITHDRAWAL' | globalTranslate }}"
            >
              <nh-count>
                <textarea
                  maxlength="2000"
                  class="form-control"
                  name="reasonForWithdrawal"
                  formControlName="reasonForWithdrawal"
                  [attr.aria-label]="
                    'REQUEST_COMMENTS_WITHDRAWAL' | globalTranslate
                  "
                  rows="5"
                  autofocus="true"
                >
                </textarea>
              </nh-count>
            </nh-field>
            <div>
              <p style="padding-bottom: 1rem">
                <strong>{{ "NOTE_WITHDRAWAL" | globalTranslate }}</strong
                ><strong>{{ ": " }}</strong
                >{{ "WITHDRAWAL_MSG_1" | globalTranslate }}
              </p>
            </div>
            <div>
              <nh-field
                class="textcolor"
                id="app_con_comments"
                label
                [mandatory]="false"
                [attr.aria-required]="false"
                label="{{ 'Appellant_Signature' | globalTranslate }}"
              ></nh-field>
              <div class="checkbox-label">
                <input
                  type="checkbox"
                  name="appellantSignSW"
                  formControlName="appellantSignSW"
                  [attr.aria-label]="'Withdrawal_Checkbox_1' | globalTranslate"
                  checkedValue="E"
                  (change)="deselect($event)"
                />
                <p
                  style="padding-left: 15px"
                  aria-hidden="true"
                  [innerHTML]="'Withdrawal_Checkbox' | globalTranslate"
                ></p>
              </div>
              <div>
                <nh-field
                  id="appellantSign"
                  label="{{ 'SIGNATURE' | globalTranslate }}"
                  class="label-section"
                  [mandatory]="true"
                  [attr.aria-required]="true"
                >
                  <input
                    type="text"
                    class="form-control"
                    name="appellantSign"
                    autofocus="true"
                    formControlName="appellantSign"
                    [attr.aria-label]="'SIGNATURE' | globalTranslate"
                    maxlength="93"
                    (input)="signatureValidator($event)"
                    required
                  />
                </nh-field>
              </div>
            </div>
          </form>
          <div class="row my-1">
            <div class="col-md-12">
              <div
                class="row mt-3 text-center py-3"
                style="padding-top: 0.5rem !important"
              >
                <div class="ms-3">
                  <button
                    id="continue"
                    class="btn d-grid btn-secondary btn-width"
                    [disabled]="appealsService.showMessageWithdrawal"
                    (click)="
                      onSubmit(
                        this.memberInfo,
                        this.appealWithdrawalForm.controls,
                        this.translatedLang
                      )
                    "
                    [disabled]="!isFormValid()"
                  >
                    {{ "SUBMIT_WITHDRAWAL" | globalTranslate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
  <div class="row my-5">
    <div class="col-md-12">
      <div class="row mt-3 text-center py-4 withdrawl-exit">
        <div class="ms-3">
          <button
            id="continue"
            class="btn d-grid btn-secondary btn-width"
            (click)="goToAppealsDashboard()"
          >
            {{ "EXIT" | globalTranslate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>